import React, { Component } from 'react'
import { Container } from 'reactstrap';
import Rating from './rating';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import httpClient from '../../httpClient';

 class AnnounceRow extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      author : ""
     }
}
  async componentWillMount() {
    let author = await httpClient.getUser(this.props.author)
    this.setState({
      author : author?.name
    })
  }

  addToFav(){
    httpClient.addToFav(this.props.currentUser._id,this.props.id,'Heberg',"Hotel "+this.props.title)
  }
  
    render() { 
        const { title,position,commune,id,author,img,link, prix ,promotion,rating,details,contact,favoris,addPanier,deleteItem,announceDetails} = this.props;
        let authorName  = this.state.author; 



        return (
            <>
              <Container className="mb-3 mt-1 px-1" style={{position:"relative"}}>
                <div className="voyadv__card row">
                
                     <div className="img-adv-hajj col-5 col-sm-4 pr-2 pl-1 pr-sm-3 pl-sm-3 py-0 m-0">
                        <img
                          style={{width: this.props.imgWidth,height:this.props.imgHeight || "235px"}}
                          className="ann__img"
                          src={img}
                          alt=""
                        />
                       </div> 
                        
                        <div className=" col-7 col-sm-8 p-0 row py-0">




                            <div className="annouce__det d-flex flex-column justify-content-start  col-12 col-md-9 pr-0">



                                <div className="agence-name-cstm">
                                   <span className="agence-name">{authorName||'Unknown'}</span>
                                </div>


                                <div className="d-flex mt-1 flex-column flex-sm-row justify-content-between align-items-sm-center mb-1">
                                    <a href={link || '/'}><h4 className="heberg-name-sr font-weight-bold text-wrap"> {title}</h4></a>
                                    {rating &&
                                      <div style={{height: "25px"}} >
                                        <Rating
                                        starts={rating}
                                        size="1.6rem"
                                        /> 
                                      </div>
                                    } 
                                </div>


                                <div className="country-Visa mt-0 mt-sm-2">{position +" "+commune||""}</div>
                                  <h5 className="sc-fc-prms mt-1 mt-lg-2 mb-lg-2 ">{announceDetails}</h5>
                                  {details &&
                                  
                                  <div className="country-Visa ann__details text-start mb-lg-1 text-wrap " >
                                  </div>
                            
                              }  
                                </div>
                                

                        


                            <div className=" d-flex flex-column flex-sm-row  flex-md-column justify-content-end justify-content-sm-between  align-items-end   col-12 col-md-3 pr-0 flex__issue">
                  

                                <div className="ann__price align-self-end mt-0 mb-1 mb-sm-0 mb-md-2">
                                    <span className="prix-advances-search text-center py-0 ">
                                      {prix} DZD
                                    </span>
                                    {promotion &&
                                    <span><img className="prom__badge" src="/imgs/Visa/promBadge.svg" alt="" /></span>
                                    }
                                    
                                </div>

                              <div className="d-flex flex-row justify-content-between flex-md-column align-items-end">
                                                       
                                



                                <div className={this.props.icons+ " "+ "d-flex" + " " +" mt-auto"}>

                                    {contact &&
                                       <div className="message-vendeur-cstm text-center mr-2 py-1">
                                          <img
                                            src="/imgs/navebar/mail.svg"
                                            alt=""
                                            className="mail-crd m-1"
                                          />
                                       </div>
                                    }

                                    {favoris &&
                                       <div className="bascet-cstm text-center mr-2 py-1 px-2 fav-btn" onClick={e=>this.addToFav()} >
                                          <img
                                            src="/imgs/navebar/heart.svg"
                                            alt=""
                                            className="heart-crd"
                                          />
                                       </div>
                                    }

                                    {addPanier &&
                                      <div className="shop-cstm p-1">
                                        <img
                                          src="/imgs/navebar/shoping.svg"
                                          alt=""
                                          className="shoping-crd"
                                        />
                                      </div>
                                    }

                                    {deleteItem &&
                                      <div className="bascet-cstm px-2 py-1">
                                          <FontAwesomeIcon icon={faTrashAlt} color="white" style={{fontSize: "16px"}}/>
                                      </div>
                                    }

                                </div>

                              </div>

                            </div>

                            </div>
                        </div>
              
                
             
                <hr style={{ width: "100%" }} className="mb-2 mt-2" />
              
              </Container>
            </>
          );
      }
  }

  function mapStateToProps(state) {
    return {
      currentUser : state.user.user,
      
    }
    }
    
    //connect function INJECTS dispatch function as a prop!!
    export default withRouter(connect(mapStateToProps)(AnnounceRow));